export enum HeaderBtnName {
  mail = "mail",
  ntfcn = "ntfcn",
  profile = "profile",
}
